var DELAY = 2000;
// const NOOP = () => {}

function loadJs(url) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = function () {
    // callback()
  };
  script.src = url;
  document.body.appendChild(script);
}
function includeLinkStyle(url) {
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
}
var legoDev = function legoDev() {
  if (window.location.href.indexOf('LEGO_DEV_MODEL=LEGO_DEV_MODEL') !== -1) {
    setTimeout(function () {
      // 源码地址 http://gitlab.zhuanspirit.com/zz-fe-common/lego-dev-model.git
      loadJs('https://s1.zhuanstatic.com/common/trade/SCORE_ITEMS_CHART.js?' + Math.random());
      includeLinkStyle('https://s1.zhuanstatic.com/common/trade/SCORE_ITEMS_CHART.css?' + Math.random());
    }, DELAY);
  }
};
export default legoDev;